var map = {
	"./0.png": "da74",
	"./1.png": "e6c5",
	"./2.png": "b96a",
	"./3.png": "e1c2",
	"./4.png": "9ec0",
	"./5.png": "447be",
	"./6.png": "4785",
	"./slot_frame.png": "4209"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0bf8";